import Cookies from 'js-cookie';
import { uuid } from './uuid';

/**
 * The getPermanentId function returns a unique identifier for the user.
 * If the user has already visited this site, it will return their existing id.
 * Otherwise, it will generate a new one and store it in cookies so that they
 * can be identified on future visits.
 *
 * @returns A unique identifier for the user
 */
export const getPermanentId = () => {
  const existingId = Cookies.get('user_id');
  if (existingId) {
    return existingId;
  }

  const permanentId = uuid();
  Cookies.set('user_id', permanentId, {
    expires: 365 * 5,
  });
  return permanentId;
};
